import React, { Component } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";
import logo from '../assets/image/logo.png';
import { _formatDateToText, _setTime, _logOut, _getToken, _isLogin, _Alert, variable, _post, _get, _getdata } from './Function';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import '../css/Header.css';

class HeaderAllPage extends Component {
  constructor() {
    super();
    this.state = {
      time: ''
    }
    this.timer = setInterval(() => {
      this.setState({ time: _formatDateToText(new Date(), '') })
    }, 1000)
    this.BaseUrl = "http://klscoop.or.th/";
    const d = new Date();
    let year = d.getFullYear();
    this.year = parseInt(year) + 543;

    _isLogin().then(value => {
      if (value) this.getMemberId();
    });
  }

  onAddTime = () => { _setTime() }

  logOut = () => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: 'ยืนยันการออกจากระบบ ?',
      text: 'คุณต้องการออกจากระบบ',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        console.log("%cClick LogOut", "color:white;background-color:gray;padding:2px;");
        _logOut()
      }
    });
  }

  getDividen() {
    // let param = { token: _getToken(), platform: variable().platform };
    axios.get('https://system.klscoop.or.th/APIs/confirm_balance_list.get.token.php?member_id=' + localStorage.getItem("member_no"))
      .then(response => {
        // console.log(response.data.token)
        window.open('https://www.klscoop.or.th/online/confirm.php?token=' + response.data.token)
      })
      .catch(error => {
        console.log(error)
      });
  }

  getCal() {
    // let param = { token: _getToken(), platform: variable().platform };
    // axios.get('https://system.klscoop.or.th/APIs/confirm_balance_list.get.token.php?member_id='+localStorage.getItem("member_no"))
    // .then(response => {
    //   // console.log(response.data.token)
    window.open('https://www.klscoop.or.th/loan/loan_main_menu_mobile.php?' + btoa('member_no=' + localStorage.getItem("member_no")))
    // })
    // .catch(error => {
    //    console.log(error)
    // });
  }

  getCalLoan() {
    // let param = { token: _getToken(), platform: variable().platform };
    window.open('https://system.klscoop.or.th/loan-calculator.html?token=' + localStorage.getItem("token"))
  }

  getWelfare() {
    window.open('https://forms.gle/JanMSQYxw6sUjrFL8')
  }


  getMemberId = () => {
    let param = { token: _getToken(), platform: variable().platform };
    _post('get.member.id.php', param).then(res => {
      this.setState({
        menuMemberId: btoa(res.data)
      });
    }).catch(err => {
      // this.props.onLoading(false);
      _Alert('error');
    });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    return (
      <div onClick={(e) => this.onAddTime()}>
        <div className="fix-content">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div nav="top" className="nav-top">
              <img className="nav-top-logo" src={logo} />
              <div className="nav-top-title-content">
                <div className="tc-1">สหกรณ์ออมทรัพย์สาธารณสุขกาฬสินธุ์ จำกัด</div>
                <div className="tc-2 n-tc-2">Kalasin Public Health Savings Cooperative Limited.</div>
              </div>
            </div>
            <div className="nav-time">{this.state.time}</div>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
              <ul className="navbar-nav navbar-nav-login nav-all-page">
                <li className="nav-item nav-active">
                  <a className="nav-link" href="/online/dashboard">หน้าแรก</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link">ข้อความ</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/online/share">หุ้น</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/online/deposit">เงินฝาก</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/online/loan">เงินกู้</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href={this.BaseUrl + 'cremationReceipt.php/' + this.state.menuMemberId}>พิมพ์ใบเสร็จสมาคมฯ</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/online/payment">พิมพ์ใบเสร็จ</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/online/guarantor">ภาระการค้ำประกัน</a>
                </li>
                <li className="nav-item">
                  {/* <a className="nav-link" href="/online/guarantor">ตรวจสอบเงินปันผล 2564</a> */}
                  <a className="nav-link"><span onClick={this.getCal}>ขอกู้เงินออนไลน์</span></a>
                </li>
                <li className="nav-item">
                  {/* <a className="nav-link" href="/online/guarantor">ตรวจสอบเงินปันผล 2564</a> */}
                  <a className="nav-link"><span onClick={this.getWelfare}>ขอรับสวัสดิการ</span></a>
                </li>
                <li className="nav-item">
                  {/* <a className="nav-link" href="/online/guarantor">ตรวจสอบเงินปันผล 2564</a> */}
                  <a className="nav-link"><span onClick={this.getCalLoan}>คำนวณสินเชื่อ</span></a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/online/password">เปลี่ยนรหัสผ่าน</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link"><span onClick={this.logOut}>ออกจากระบบ</span></a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <div className="nav-islogin">
          <span><Link to="/online/dashboard">หน้าแรก</Link></span>
          <span><Link to="/online/share">หุ้น</Link></span>
          <span><Link to="/online/deposit">เงินฝาก</Link></span>
          <span><Link to="/online/loan">เงินกู้</Link></span>
          <span><a href={this.BaseUrl + 'cremationReceipt.php/' + this.state.menuMemberId}>พิมพ์ใบเสร็จสมาคมฯ</a></span>
          <span><Link to="/online/payment">พิมพ์ใบเสร็จ</Link></span>
          <span><Link to="/online/guarantor">ภาระการค้ำประกัน</Link></span>
          {/* <span onClick={this.getDividen}>ตรวจสอบเงินปันผล {this.year}</span> */}
          <span onClick={this.getCal}>ขอกู้เงินออนไลน์</span>
          <span onClick={this.getWelfare}>ขอรับสวัสดิการ</span>
          <span onClick={this.getCalLoan}>คำนวณสินเชื่อ</span>
          <span><Link to="/online/password">เปลี่ยนรหัสผ่าน</Link></span>
          <span onClick={this.logOut}>ออกจากระบบ</span>
        </div>
      </div>
    );
  }
}
export default HeaderAllPage;